import { render } from "./BaseSelect.vue?vue&type=template&id=be2c32f0"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script